import tw from "twin.macro";

export const SectionHeading = tw.h2`text-4xl sm:text-5xl font-black tracking-wide text-center`
export const Subheading = tw.h5`font-bold `
{/* login page */} 
export const Heading = tw.h1`text-2xl xl:text-3xl font-extrabold`;
export const Sub_Heading = tw.h1`text-2xl xl:text-2xl font-extrabold`;
